import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { mdiCheck } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const UnassignedWorkOrdersEmptyState: FC<
  UnassignedWorkOrdersEmptyStateProps
> = ({ selectedTabLabel }) => {
  const { classes, theme } = useStyles();
  const text = selectedTabLabel
    ? `No Unassigned ${selectedTabLabel}`
    : "No Unassigned Work Orders";

  return (
    <Box className={classes.root}>
      <Box className={classes.iconContainer}>
        <MiIcon
          path={mdiCheck}
          color={theme.palette.grey.darkerAccent}
          size={1.2}
        />
      </Box>
      <Typography variant={TYPOGRAPHY_VARIANTS.HD4}>{text}</Typography>
    </Box>
  );
};

interface UnassignedWorkOrdersEmptyStateProps {
  selectedTabLabel?: string | null;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  iconContainer: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
